module.exports = __webpack_public_path__ + "img/product4.b8c7fb23.png";